import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { UtilsService } from "../../../../auth/service/utils.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CitiesService } from "../../../../auth/service/cities.service";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { ContractService } from "../../../../auth/service/contract.service";
import { RoleService } from "../../../../auth/service/role.service";
import * as moment from "moment";
import worldNationalities from "../../../../auth/models/nationality";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JobSiteService } from "../../../../auth/service/job-sites.service";
import { ManageEmployeeContractService } from "../../../../auth/service/manage-employee-contract.service";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-user-form-add",
  templateUrl: "./user-form-add.component.html",
  styleUrls: ["./user-form-add.component.scss"],
})
export class UserFormAddComponent implements OnInit {
  public user_type: any;
  public formGroup: FormGroup;
  public contentHeader: IContentHeader;
  public user_type_name: string = italian.data.TITLES.USERS;
  public active_table: string = "masterdata";
  public showErrors: boolean = false;
  public today_date: string;
  public min_birthdate: string;
  public addressResidence_FormGroup: FormGroup;
  public nationalities_list: Array<string> = worldNationalities;
  public hr_list: any = [];
  public contractFile: any;
  public fileName: string = null;
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;

  constructor(
    public _citiesService: CitiesService,
    public _contractService: ContractService,
    public _userFigureService: UserFigureService,
    public _roleService: RoleService,
    public _manageContract: ManageEmployeeContractService,
    private _formBuilder: FormBuilder,
    public _userService: UserService,
    public _utilService: UtilsService,
    private router: Router,
    private activated_route: ActivatedRoute,
    public _modalService: NgbModal,
    public _jobSiteService: JobSiteService,
    public _authenticationService: AuthenticationService,
    private _changeDetector: ChangeDetectorRef,
  ) {
    this.today_date = moment().format("YYYY-MM-DD");
    this.min_birthdate = moment().subtract(18, "year").format("YYYY-MM-DD");
    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      this.user_type = params.get("user_type");
      if (!this._userService.types.includes(this.user_type)) {
        this._utilService.hideLoading();
        await this.router.navigateByUrl("/dashboard/main");
        return false;
      }
      this.user_type_name = await this._utilService.translate(italian.data.TITLES.USERS_TYPES[this.user_type]);
      this.contentHeader.headerTitle = this.user_type_name;
      this.contentHeader.breadcrumb.links[1].name = this.user_type_name;
    });

    this.addressResidence_FormGroup = this._formBuilder.group({
      street: new FormControl("", [Validators.required]),
      zipcode: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      city: new FormControl(0, [Validators.required, Validators.min(1)]),
      province: new FormControl(0, [Validators.required, Validators.min(1)]),
      external: new FormControl(false),
      country: new FormControl(null),
    });

    this.formGroup = this._formBuilder.group({
      firstname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      sex: new FormControl("m"),
      birthday: new FormControl(""),
      figure: new FormControl("", [Validators.required]),
      department: new FormControl(""),
      birth_place: new FormControl(""),
      phone: new FormControl("", [Validators.required, Validators.minLength(9), Validators.maxLength(15)]),
      email: new FormControl("", [Validators.required, Validators.email]),
      private_email: new FormControl("", [Validators.required, Validators.email]),
      send_welcome_email: new FormControl(""),
      fiscal_code: new FormControl("", [Validators.maxLength(16), Validators.minLength(16)]),
      nationality: new FormControl(null),
      iban: new FormControl("", [Validators.maxLength(34), Validators.minLength(15)]),
      badge_number: new FormControl(null, [Validators.maxLength(10), Validators.minLength(1)]),
      civil_status: new FormControl(""),
      child_number: new FormControl(0, [Validators.min(0)]),
      need_assets: new FormControl(0),
      send_onboarding: new FormControl(0),
      residual_holidays: new FormControl(0, [Validators.min(0)]),
      residual_permissions: new FormControl(0, [Validators.min(0)]),
      working_city: new FormControl(""),
      role: new FormControl("", [Validators.required]),
      site: new FormControl(""),
      reference_hr: new FormControl(""),
    });

    this.contentHeader = {
      headerTitle: this.user_type_name,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.TITLES.USERS,
            isLink: true,
            link: `/dashboard/user/list/${this.user_type}`,
          },
          {
            name: italian.data.ADD,
            isLink: false,
          },
        ],
      },
    };
  }

  ngOnDestroy() {
    this._manageContract.resetData();
  }

  async ngOnInit() {
    await this._manageContract.init();

    this.hr_list = await this._userService.getList("employee", "HR").then((list: any) =>
      list.map((item) => {
        return { hash: item.hash, name: `${item.firstname} ${item.lastname}` };
      }),
    );

    const int: any = setInterval(() => {
      if (this._roleService.list.length > 0) {
        const roleEmployee: any = this._roleService.list.find((role: any) => role.name === "Dipendente");
        this.formGroup.patchValue({ role: roleEmployee.id });
        this._changeDetector.detectChanges();
        clearInterval(int);
      }
    }, 1000);
  }

  handlerChangeChild() {
    const childNumber: number = Number(this.formGroup.get("child_number").value);
    this.formGroup.patchValue({ has_child: childNumber > 0 ? 1 : 0 });
  }

  setResidenceProvinces() {
    const residenceCityValue: number = this.addressResidence_FormGroup.get("city").value;
    if (residenceCityValue > 0) {
      const residenceCity: any = this._citiesService.list.find((city: any) => city.id === residenceCityValue);
      const province = this._citiesService.list.find((city: any) => city.initials === residenceCity.initials && city.is_main === 1);
      this.addressResidence_FormGroup.patchValue({ province: province.id });
    }
  }

  hasCapability(name: string) {
    return this._authenticationService.hasCapability(name);
  }

  handlerChangeFileInput(event: any) {
    this.fileName = event.target.files[0].name;
    this._utilService.convertFileToBase64(event, (e: any) => {
      this.contractFile = e.target.result;
    });
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup?.controls[field_name]?.status === "INVALID" || this.addressResidence_FormGroup?.controls[field_name]?.status === "INVALID";
    } else {
      return (
        (this.formGroup?.controls[field_name]?.status === "INVALID" && this.formGroup?.controls[field_name]?.touched) ||
        (this.addressResidence_FormGroup?.controls[field_name]?.status === "INVALID" && this.addressResidence_FormGroup?.controls[field_name]?.touched)
      );
    }
  }

  async submit() {
    if (!this._authenticationService.hasCapability("create_user")) {
      window.history.back();
      return false;
    }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid || this.addressResidence_FormGroup.invalid) {
      return false;
    }

    //controlli alert
    // contract
    if (this._manageContract.typeIsIndeterminate) {
      if (!this._manageContract.data.contract || !this._manageContract.data.level || !this._manageContract.data.start_date || !this._manageContract.data.program || !this._manageContract.data.salary_yearly_gross) {
        await this._utilService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        this.active_table = "contract";
        return false;
      }
    } else if (this._manageContract.typeIsStage) {
      if (!this._manageContract.data.contract || !this._manageContract.data.start_date || !this._manageContract.data.program || !this._manageContract.data.net_monthly_12 || !this._manageContract.data.end_date) {
        await this._utilService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        this.active_table = "contract";
        return false;
      }
    } else {
      //Nel caso di apprendistato o determinato
      if (
        !this._manageContract.data.contract ||
        !this._manageContract.data.level ||
        !this._manageContract.data.start_date ||
        !this._manageContract.data.program ||
        !this._manageContract.data.net_monthly_12 ||
        !this._manageContract.data.end_date
      ) {
        await this._utilService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        this.active_table = "contract";
        return false;
      }
    }
    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressResidence_FormGroup.controls).map((key) => {
      if (this.addressResidence_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    if (this.formGroup.invalid || this.addressResidence_FormGroup.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      keyToShowError.map((item, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });
      if (this.formGroup.controls.figure.status === "INVALID" || this.formGroup.controls.private_email.status === "INVALID" || this.formGroup.controls.phone.status === "INVALID") {
        this.active_table = "informations";
      } else {
        this.active_table = "masterdata";
      }

      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    //Fine controlli alert
    if (!this.buttonIsEnabled()) return false;

    let payload: any = { ...this.formGroup.value, type: this.user_type };
    payload.need_assets = payload.need_assets ? 1 : 0;
    payload.send_onboarding = payload.send_onboarding ? 1 : 0;
    payload.birthday = this.formGroup.controls.birthday.touched && payload.birthday.length > 0 ? payload.birthday : null;

    payload.firstname = this._utilService.ucFirst(payload.firstname);

    if (this.addressResidence_FormGroup.valid) {
      payload.addresses = {
        residenza: {
          city: this.addressResidence_FormGroup.value.city,
          country: this.addressResidence_FormGroup.value.country,
          province: this.addressResidence_FormGroup.value.province,
          street: this.addressResidence_FormGroup.value.street,
          zipcode: this.addressResidence_FormGroup.value.zipcode,
        },
      };
    }

    payload.contract = { ...this._manageContract.data, record_type: "contratto" };
    if (this._manageContract.data.contract === 4) {
      //Controllo in caso di contratto a stage elimino campi superflui
      payload.contract.bonus = null;
      payload.contract.gross_monthly_12 = null;
      payload.contract.level = null;
      payload.contract.net_monthly_13 = null;
      payload.contract.salary_yearly_gross = null;
      payload.contract.ticket_month_number = null;
      payload.contract.ticket_type = null;
      payload.contract.ticket_value = null;
      payload.contract.total_net_monthly_13 = null;
      payload.contract.trial = null;
    }
    payload.phone = payload.phone.replace(/ /g, ""); //Rimozione spazi
    this._utilService.showLoading();

    await this._userService
      .create(payload)
      .then(async (data: any) => {
        if (data.hash) {
          if (this.contractFile) {
            let contractFileName: any = this._contractService.list.find((contract: any) => contract.id === payload.contract.contract);
            contractFileName = `users/${data.hash}/Contratto-${contractFileName.name}-${moment().valueOf()}.pdf`;

            const uploadContract: any = await this._utilService.upload_media("documents", contractFileName, this.contractFile);
            if (!uploadContract) {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "ERROR_UPLOAD_CONTRACT" });
            }
            await this._userService.update(data.hash, { contract_url: contractFileName }).then(async () => {
              let confirmationText: string = await this._utilService.translate("ALERT.SUCCESS_UPLOAD_USER");
              confirmationText += " ";
              confirmationText += await this._utilService.translate("ALERT.WOULD_YOU_ADD_ATTACCHMENTS");
              this._utilService.hideLoading();
              await this._utilService
                .showSWALDeleteConfirmation({
                  title: "COMPLETED_TITLE",
                  text: confirmationText,
                  icon: "success",
                  confirmButtonText: "YES_BUTTON",
                  cancelButtonText: "NO_BUTTON",
                  customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-danger",
                  },
                })
                .then(async (result) => {
                  if (result.value) {
                    this._utilService.hideLoading();
                    await this.router.navigate(["/dashboard/user/edit/" + data.hash], { queryParams: { attachments: "yes" } });
                  } else if (result.isDismissed) {
                    this._utilService.hideLoading();
                    await this.router.navigateByUrl("/dashboard/user/edit/" + data.hash);
                  }
                });
            });
          } else {
            await this.router.navigateByUrl("/dashboard/user/edit/" + data.hash).then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_USER" });
            });
          }
        } else {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            text: "ERROR_UPLOAD_USER",
          });
        }
      })
      .catch(async (errorMessage: string) => {
        this._utilService.hideLoading();
        console.error({ errorMessage });
        await this._utilService.showSWALError({
          text: "ERROR_UPLOAD_USER",
        });
      });
  }

  transformRal(value: any) {
    const splittedValue: any = value.split("");

    if (value.includes(",") && splittedValue[splittedValue.length - 3] === "," && value.includes(".") && splittedValue[2] === ".") {
      value = this._utilService.removeDotsFromNumber(value);
    } else {
      // se include il punto e il punto è usato a index 2 - rimuovo quel punto
      if (value.includes(".") && splittedValue[2] === ".") {
        value = value.split("");
        delete value[2];
        value = value.join("");
      }
      // se include la virgola e la virgola è alla index 2 - rimuovo quella virgola
      if (value.includes(",") && splittedValue[2] === ",") {
        value = value.split("");
        delete value[2];
        value = value.join("");
      }
      // se include la virgola ed è il separatore dei decimali
      if (value.includes(",") && splittedValue[splittedValue.length - 3] === ",") {
        value = value.split("");
        value[-2] = ".";
        value = value.join("");
      }
    }

    value = Number(value);

    this._manageContract.changeSalaryGrossYearly(value);
  }

  buttonIsEnabled() {
    if (this._manageContract.data.contract === 4) {
      //Controllo in caso di contratto a stage
      if (
        this._manageContract.data.role === "" ||
        this._manageContract.data.contract < 1 ||
        Number(this._manageContract.data.net_monthly_12) < 1 ||
        this._manageContract.data.start_date === "" ||
        Number(this._manageContract.data.total_daily_with_bonus) < 1 ||
        !this._manageContract.data.tutor_hash ||
        !this._manageContract.data.end_date
      ) {
        return false;
      }
      return true;
    }
    return (
      this.formGroup.valid &&
      this.addressResidence_FormGroup.valid &&
      this._manageContract.data.level !== "" &&
      this._manageContract.data.role &&
      this._manageContract.data.start_date &&
      this._manageContract.data.salary_yearly_gross
    );
  }

  async checkEmptyFieldAlert() {
    //controlli alert

    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressResidence_FormGroup.controls).map((key) => {
      if (this.addressResidence_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    if (this.formGroup.invalid || this.addressResidence_FormGroup.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      keyToShowError.map((item, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });
      if (this.formGroup.controls.figure.status === "INVALID" || this.formGroup.controls.private_email.status === "INVALID" || this.formGroup.controls.phone.status === "INVALID") {
        this.active_table = "informations";
      } else {
        this.active_table = "masterdata";
      }

      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    //contract
    if (this._manageContract.typeIsIndeterminate) {
      if (!this._manageContract.data.contract || !this._manageContract.data.level || !this._manageContract.data.start_date || !this._manageContract.data.program || !this._manageContract.data.salary_yearly_gross) {
        await this._utilService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        this.active_table = "contract";
        return false;
      }
    } else if (this._manageContract.typeIsStage) {
      if (!this._manageContract.data.contract || !this._manageContract.data.start_date || !this._manageContract.data.program || !this._manageContract.data.net_monthly_12 || !this._manageContract.data.end_date) {
        await this._utilService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        this.active_table = "contract";
        return false;
      }
    } else {
      //Nel caso di apprendistato o determinato
      if (
        !this._manageContract.data.contract ||
        !this._manageContract.data.level ||
        !this._manageContract.data.start_date ||
        !this._manageContract.data.program ||
        !this._manageContract.data.net_monthly_12 ||
        !this._manageContract.data.end_date
      ) {
        await this._utilService.showSWALError({ text: "CONTRACT_NOT_COMPLETE" });
        this.active_table = "contract";
        return false;
      }
    }
    //Fine controlli alert
  }

  manageExternalSiteResidence() {
    if (this.addressResidence_FormGroup.value.external) {
      this.addressResidence_FormGroup.get("country").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("city").clearValidators();
      this.addressResidence_FormGroup.get("zipcode").clearValidators();
      this.addressResidence_FormGroup.get("province").clearValidators();
      this.addressResidence_FormGroup.patchValue({
        province: null,
        city: null,
        zipcode: null,
      });
    } else {
      this.addressResidence_FormGroup.patchValue({
        country: null,
      });
      this.addressResidence_FormGroup.get("country").clearValidators();
      this.addressResidence_FormGroup.get("province").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("city").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.minLength(5));
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.maxLength(5));
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.pattern("[0-9]+"));
    }
    this.addressResidence_FormGroup.get("country").updateValueAndValidity();
    this.addressResidence_FormGroup.get("city").updateValueAndValidity();
    this.addressResidence_FormGroup.get("zipcode").updateValueAndValidity();
    this.addressResidence_FormGroup.get("province").updateValueAndValidity();
  }
}
